export class VivawalletCustomer {

    constructor(
        public email: string,
        public fullName: string,
        public phone: string | null,
        public countryCode: string | null,
        public requestLang: string | null
    ){}
}
